import { createContext, useState, useContext, ReactNode } from "react";
import { auth, signIn } from "../utils/firebase";
import { toast } from "react-toastify";
import { routes } from "../Router";

interface LoginContextProps {
  email: string;
  password: string;
  loading: boolean;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  onClickLogin: (navigate: (path: string) => void) => Promise<void>;
}

const LoginContext = createContext<LoginContextProps | undefined>(undefined);

export const LoginContextProvider = ({ children }: { children: ReactNode }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onClickLogin = async (navigate: (path: string) => void) => {
    if (!email || !password) {
      toast.error("Por favor ingrese su email y contraseña");
      return;
    }
    setLoading(true);
    try {
      const userCredential = await signIn(auth, email, password);
      toast.success("Sesión iniciada correctamente");

      const expiryTime = (userCredential as any).user.stsTokenManager.expirationTime;
      // Establecer tiempo de expiración (2 horas)
      localStorage.setItem('tokenExpiry', expiryTime.toString());

      navigate(routes.adminOrders.path);
    } catch (error: any) {
      const errorMessage =
        error.code === "auth/invalid-email"
          ? "Email no encontrado"
          : error.code === "auth/invalid-credential"
          ? "Contraseña incorrecta"
          : "Error al iniciar sesión. Verifique sus credenciales.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContext.Provider
      value={{ email, password, loading, setEmail, setPassword, onClickLogin }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => {
  const context = useContext(LoginContext);
  if (context === undefined) {
    throw new Error("useLogin must be used within a LoginProvider");
  }
  return context;
};